import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import css from "./pageheader.module.scss";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showDeleteButton?: boolean;
  onDelete?: () => void;
  deleteButtonText?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  showDeleteButton = false,
  onDelete,
  deleteButtonText,
}) => {
  return (
    <Box className={css.pageHeader}>
      <Box className={css.headerContent}>
        <Box>
          <Typography variant="h6" className={css.title}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" className={css.subtitle}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {showDeleteButton && onDelete && (
          <IconButton
            className={css.deleteButton}
            onClick={onDelete}
            aria-label="delete"
          >
            {deleteButtonText && (
              <span className={css.deleteButtonText}>{deleteButtonText}</span>
            )}
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default PageHeader;
